import coreCollections from 'rlink-collections/core';

import constructsUsingImpl from './constructsUsing';
import copyGeneratorImpl from './copyGenerator';
import isIterableImpl from './isIterable';

const immutableCollections = coreCollections.withImplementations({
  constructsUsing: constructsUsingImpl,
  copyGenerator: copyGeneratorImpl,
  isIterable: isIterableImpl,
});
export default immutableCollections;

const {
  average,
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  groupBy,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  sum,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
} = immutableCollections;

export {
  average,
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  groupBy,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  sum,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/immutable/index.js